/**
 * Pre-compiled de messages for LoadingSpinner
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { default: `Daten werden geladen` };
